import React from 'react';

const Logo = ({ className = "w-10 h-10", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 100 100" 
    className={className} 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer Hexagon */}
    <path 
      d="M50 5L89 27.5V72.5L50 95L11 72.5V27.5L50 5Z" 
      stroke={color} 
      strokeWidth="6" 
      strokeLinejoin="round"
      className="drop-shadow-[0_0_8px_rgba(0,229,115,0.5)]"
    />
    {/* Inner Diamond Core */}
    <path 
      d="M50 30L65 50L50 70L35 50L50 30Z" 
      fill={color}
      className="animate-pulse"
    />
    {/* Dynamic Accents */}
    <path d="M50 15V22" stroke={color} strokeWidth="4" strokeLinecap="round" />
    <path d="M50 78V85" stroke={color} strokeWidth="4" strokeLinecap="round" />
    <path d="M22 65L28 61.5" stroke={color} strokeWidth="4" strokeLinecap="round" />
    <path d="M72 35L78 31.5" stroke={color} strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export default Logo;